const UiMeet3dLinkRole = {
  ADMIN: "admin",
  AGENT: "agent",
  BOT: "bot",
  EDITOR: "editor",
  OWNER: "owner",
  PROVIDER: "provider",
  VISITOR: "visitor",
};

export default UiMeet3dLinkRole;
